module.exports = __webpack_public_path__ + "static/media/dubai.7caad1f0.jpg";